import { prepareFormToSubmit } from 'UI/utils/forms';

import { buildResolvedEmailBody } from '../../forms/EmailDetails/EmailDetails.utils';
import { ATTACHMENT_FIELD_KEYS } from '../CreateSendoutDrawer/SendoutForm/SendoutForm.utils';

import { FORM_FIELDS_MAP, SENDOVER_TEMPLATE_ID } from './SendoverForm/SendoverForm.constants';

export const getSelectedAttachments = formData =>
  ATTACHMENT_FIELD_KEYS.flatMap(fieldKey => formData?.[fieldKey] || []);

export const prepareSendoverPayload = ({
  formData = {},
  jobOrder = {},
  resolvedEmailBody = ''
}) => {
  const preparedFormData = prepareFormToSubmit(formData, FORM_FIELDS_MAP);

  return {
    ...preparedFormData,
    template: resolvedEmailBody,
    company_id: jobOrder?.company?.id ?? null,
    job_order_id: jobOrder?.id ?? null,
    hiring_authorities: jobOrder?.hiringAuthorities || [],
    type_id: 2, // revisar
    status_id: 5, // revisar
    send_email: true, // misma logica que sendout. hay que negar
    template_id: SENDOVER_TEMPLATE_ID
  };
};

export const buildSendoverSubmissionData = ({
  formData = {},
  jobOrder = {},
  candidateInfo = {}
}) => {
  const { resolvedEmailBody, resolvedTagValues } = buildResolvedEmailBody({
    emailBody: formData[FORM_FIELDS_MAP.EmailBody.key],
    hiringAuthority: formData[FORM_FIELDS_MAP.HiringAuthority.key],
    candidate: formData[FORM_FIELDS_MAP.Candidate.key],
    jobOrder,
    candidateInfo
  });

  return {
    payload: prepareSendoverPayload({ formData, jobOrder, resolvedEmailBody }),
    confirmation: {
      resolvedEmailBody,
      resolvedTagValues
    }
  };
};
